var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlmostNever(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 208,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-400 -256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.676 204.165C81.7125 204.176 50.1173 172.599 50.1062 133.636 50.0951 94.6723 81.6722 63.0771 120.636 63.066 159.599 63.0549 191.194 94.632 191.206 133.595 191.206 133.602 191.206 133.609 191.206 133.616 191.275 172.51 159.802 204.096 120.908 204.165 120.831 204.165 120.753 204.165 120.676 204.165ZM180.374 72.1366 187.931 64.5798C190.755 61.5781 190.642 56.8644 187.679 54.0004 184.763 51.1586 180.148 51.0485 177.1 53.7485L168.535 62.5647C156.552 54.4463 142.663 49.585 128.233 48.4588L128.233 37.8794 150.903 37.8794 150.903 22.7659 90.4491 22.7659 90.4491 37.8794 113.119 37.8794 113.119 48.2069C65.869 52.318 30.898 93.9549 35.0093 141.205 39.1205 188.455 80.7573 223.426 128.007 219.315 175.258 215.204 210.229 173.567 206.117 126.317 204.328 105.749 195.189 86.5153 180.374 72.1366Z",
    transform: "matrix(1.00715 0 0 1 370.11 240.565)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.125 133.578C181.086 100.206 154.042 73.1628 120.671 73.124L120.671 133.578Z",
    transform: "matrix(1.00715 0 0 1 370.11 240.565)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlmostNever);
export default __webpack_public_path__ + "static/media/almost-never.99ce42672b5c5e84201730a2652f56b5.svg";
export { ForwardRef as ReactComponent };